import script from "./groupCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./groupCalendar.vue?vue&type=script&setup=true&lang=js"

import "./groupCalendar.vue?vue&type=style&index=0&id=73c5cc2d&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c5cc2d"]])

export default __exports__